import moment from 'moment';
import get from 'lodash/get';
import isString from 'lodash/isString';
import { LOG_TYPE } from '../const';
import { logger } from '../logger/logger.class';
function hasLocalStorage() {
    if (!localStorage) {
        logger.message('No localstorage available', LOG_TYPE.error);
        return false;
    }
    return true;
}
function hasValidName(name) {
    return name && isString(name);
}
/**
 * Processes and saves the data in localstorage
 * @param name localstorage entry name
 * @param id ID to match for future reference
 * @param storedData string or object saved in localstorage
 * @param validFor period of localstorage validity in hours
 */
export function setItem(name, id, storedData, validFor = 24) {
    if (!hasLocalStorage()) {
        logger.message(`No localstorage available to set ${name}`, LOG_TYPE.error);
        return null;
    }
    const validUntil = moment().add(validFor, 'hours').unix();
    const storageItem = JSON.stringify(({ [id]: storedData, validUntil }));
    localStorage.setItem(name, storageItem);
}
/**
 * Retrieves an item from localstorage by name and evaluates it's validity before returning to users
 * @param name localstorage entry name
 */
export function getItem(name) {
    if (hasLocalStorage() && hasValidName(name)) {
        const storageItem = localStorage.getItem(name);
        const parsedStorageItem = JSON.parse(storageItem);
        const validUntil = get(parsedStorageItem, 'validUntil');
        const now = moment().unix();
        const isKeyValid = (validUntil > now);
        if (!isKeyValid) {
            clearItem(name);
        }
        return isKeyValid ? parsedStorageItem : null;
    }
    else {
        logger.message(`No localstorage available or unable to read ${name}`, LOG_TYPE.error);
        return null;
    }
}
/**
 * Deletes an item from localstorage
 * @param name localstorage entry name
 */
export function clearItem(name) {
    if (hasLocalStorage() && hasValidName(name)) {
        localStorage.removeItem(name);
        logger.message(`${name} removed from localstorage`, LOG_TYPE.error);
    }
    else {
        logger.message(`No localstorage available or unable to read ${name}`, LOG_TYPE.error);
    }
}
export const rehydrate = {
    set: setItem,
    get: getItem,
    clear: clearItem,
};
